/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";

import { Text } from "UpduoLibrary";
import { generateCountdownString } from "config/Utilities";

interface CountdownTimerProps {
  currentTime: Date;
  countdownEnd: Date;
  color: string;
  style?: StyleProp<ViewStyle>;
}

export default function CountdownTimer({
  currentTime,
  countdownEnd,
  color,
  style,
}: CountdownTimerProps) {
  return (
    <View
      style={[
        style,
        {
          padding: 4,
          borderWidth: 1,
          borderColor: color,
          borderRadius: 4,
        },
      ]}
    >
      <Text style={{ color, fontSize: 14, lineHeight: 15 }}>
        {generateCountdownString(countdownEnd, currentTime)}
      </Text>
    </View>
  );
}
